import React from 'react';
//import { useFetch } from "../hooks/useFetch";
//import Loader from "../componentssturtural/Loader";
import MessageDetail from "../../components/sturtural/MessageDetail";
import TableRow from "../../components/sturtural/TableRow";

const TableData = ({thead, data, handleAssignment}) => {
    return (
        <div>
            {data.length > 0 ? (
                <table className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            {thead.map((el, index) =>
                                <th scope="col" key={`head-${index}`}>{el}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((el, index) => 
                            <TableRow key={index} el={el} order={index} handleAssignment={handleAssignment} />
                        )}
                    </tbody>
                </table>
            ):(
                <MessageDetail mensaje="No se encontraron solicitudes registradas"/>
            )}
        </div>
    );  
}

export default TableData;